var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("d-flex lead-bottom-control-panel\n  " + (_vm.theme.isDark ? 'lead-bottom-control-panel_dark' : '') + " \n  " + (_vm.call && _vm.online
      ? 'lead-bottom-control-panel_show'
      : 'lead-bottom-control-panel_hide'))},[_c('CallControll')],1)}
var staticRenderFns = []

export { render, staticRenderFns }